import type { KambiValidReward } from '@mobi/api-types/kambi/player/reward'
import { SelectKambiReward } from '@core/Areas/Quickbet/signals'

export function autoSelectDefaultReward(allRewards: KambiValidReward[]): void {
  const rewardsWithAutoSelect = allRewards.filter(reward =>
    reward.metadata?.tags.some(tag => tag.key === 'autoSelect')
  )

  if (rewardsWithAutoSelect.length === 1) {
    SelectKambiReward(rewardsWithAutoSelect[0])
  } else if (rewardsWithAutoSelect.length > 1) {
    SelectKambiReward(determineAutoSelectedReward(rewardsWithAutoSelect))
  }
}

// =============
// Local Helpers
// =============

function determineAutoSelectedReward(rewards: KambiValidReward[]): KambiValidReward {
  let autoSelectReward = rewards[0]

  const profitBoostRewards = rewards.filter(reward => reward.rewardType === 'PROFIT_BOOST')
  const oddsBoostRewards = rewards.filter(reward => reward.rewardType === 'ODDS_BOOST')

  if (oddsBoostRewards.length) {
    const highestOddsBoostedReward = oddsBoostRewards.reduce((highest, curr) => {
      if (!curr.oddsBoostProperties) return highest
      return curr.oddsBoostProperties.boostedOdds > (highest.oddsBoostProperties?.boostedOdds || 0)
        ? curr
        : highest
    }, oddsBoostRewards[0])

    autoSelectReward = highestOddsBoostedReward
  } else if (profitBoostRewards.length) {
    const highestOddsBoostedReward = profitBoostRewards.reduce((highest, curr) => {
      if (!curr.profitBoostProperties) return highest
      return curr.profitBoostProperties.boostPercentage >
        (highest.profitBoostProperties?.boostPercentage || 0)
        ? curr
        : highest
    }, profitBoostRewards[0])

    autoSelectReward = highestOddsBoostedReward
  }

  return autoSelectReward
}
